import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from './config';
import { MenuKey } from '../../schema/menu-schema/common';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { FileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { RenameFeature } from './rename-feature';

@Controller({
    menuItems: MENU_CONFIGS,
})
export class RenameController {
    constructor(private readonly feature: RenameFeature) {
    }

    @Menu(MenuKey.RENAME, 'shouldHide')
    public shouldHide() {
        return !(appConfigInstance.getConfig(FileMenuConfig.rename as any) ?? false);
    }
    @Menu(MenuKey.RENAME, 'onClick')
    public handleClick() {
        return this.feature.handleClick();
    }
}
